<template>
  <div class="fn-layout">
    <Navbar />
    <div class="fn-layout__page">
      <AppMain />
    </div>
  </div>
</template>

<script>
import AppMain from './components/AppMain.vue'
import Navbar from './components/Navbar.vue'

export default {
  name: 'Layout',
  components: { AppMain, Navbar }
}
</script>

<style lang="scss" scoped>
.fn-layout { min-height: 100vh; background: #f5f7fa; }
.fn-layout__page { padding: 76px 16px 0; width: 98%; margin: 0 auto; overflow: hidden; }
</style>
